import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { font, palette } from 'styled-theme';
import { ifProp } from 'styled-tools';

const StyledInput = styled.input`
  border: solid 2px ${ifProp('invalid', palette('secondary', 0), palette('white', 0))};
  color: ${ifProp('invalid', palette('secondary', 0), palette('grayscale', 0))};
  font-family: ${font('primary')}, ${font('secondary')};
  padding: 0.3rem 1.5rem;
  box-sizing: border-box;
  display: block;
  text-align: center;
  line-height: 1.5;
  font-size: 2rem;
  width: 100%;
  outline: 0;
`;

const Input = ({ value, onChange, invalid, ...props }) => {
  return (
    <StyledInput
      value={value}
      onChange={(e) => onChange(e.target.value)}
      invalid={invalid}
      {...props}
    />
  );
};

Input.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  invalid: PropTypes.bool,
};

Input.defaultProps = {
  value: '',
  onChange: () => {},
  invalid: false,
};

export default Input;
